const TIME = {
    ACCOUNT: {
        cookieTtlInMilliseconds: 14 * 24 * 60 * 60 * 1000,
    },
};

export default TIME;



// WEBPACK FOOTER //
// ./src/constants/time.js